var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as Sentry from "@sentry/browser";
import { EValueType } from "../logger.types";
var logger = {
    key: "sentry",
    setValue: function (_a) {
        var _b;
        var type = _a.type, value = _a.value;
        var mappedType = type;
        switch (type) {
            case EValueType.UserId:
                mappedType = "id";
                break;
            case EValueType.UserEmail:
                mappedType = "email";
                break;
            case EValueType.Locale:
            default:
                break;
        }
        // setUser replaces the whole user object, and id, email and locale arrive in separate
        // calls - so merge with what is already on the scope or only the last one survives.
        var scope = Sentry.getCurrentScope();
        scope.setUser(__assign(__assign({}, scope.getUser()), (_b = {}, _b[mappedType] = "".concat(value), _b)));
    },
    clearValues: function () {
        // Sign-out: without this the previous user stays attached to every later event in the tab.
        Sentry.getCurrentScope().setUser(null);
    },
    logEvent: function (_a) {
        var type = _a.type, name = _a.name, _b = _a.parameters, parameters = _b === void 0 ? {} : _b;
        Sentry.addBreadcrumb({
            message: name,
            category: type,
            data: parameters,
        });
    },
    logError: function (_a) {
        var error = _a.error, fatal = _a.fatal, _b = _a.parameters, parameters = _b === void 0 ? {} : _b;
        var axiosError = error;
        if (axiosError.isAxiosError) {
            // INFO: Do not track Axios network errors. Axios errors are tracked in interceptor.response.logger
            return;
        }
        var parametersAsExtra = {
            fatal: "".concat(fatal || false),
        };
        Object.keys(parameters).forEach(function (parameterKey) {
            var parameterValue = parameters[parameterKey];
            if (typeof parameterValue === "number") {
                parametersAsExtra[parameterKey] = "".concat(parameterValue);
                return;
            }
            parametersAsExtra[parameterKey] = parameterValue;
        });
        Sentry.captureException(error, {
            extra: parametersAsExtra,
        });
    },
};
// eslint-disable-next-line import/no-default-export
export default logger;
